import { Navigate, RouteObject } from "react-router";
import { ConfirmationIndexRoute } from "@/routes/processes/[processId]/htz/confirmations/_components/confirmation-index-route";
import { ConfirmationRoute } from "@/routes/processes/[processId]/htz/confirmations/[confirmationId]/confirmation-route";
import { DataRoute } from "@/routes/processes/[processId]/htz/confirmations/[confirmationId]/data/data-route";
import { PositionsRoute } from "@/routes/processes/[processId]/htz/confirmations/[confirmationId]/positions/positions-route";
import { AddressesAndContactsRoute } from "@/routes/processes/[processId]/htz/confirmations/[confirmationId]/addresses-and-contacts/addresses-and-contacts-route";

export const htzConfirmationsRoutes: RouteObject[] = [
  {
    index: true,
    element: <ConfirmationIndexRoute />,
  },
  {
    path: ":confirmationId",
    element: <ConfirmationRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <DataRoute />,
      },
      {
        path: "positions",
        element: <PositionsRoute />,
      },
      {
        path: "addresses-and-contacts",
        element: <AddressesAndContactsRoute />,
      },
    ],
  },
];
